import PropTypes from 'prop-types';
import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import connect from '../utils/connect';
import Table from '../components/common/TableLegacy';
import ErrorBoundary from '../ErrorBoundary';
import CrashedComponent from '../components/errors/CrashedComponent';
import buildHeaders from './pacing-columns';
import pacingActions from '../actions/pacing';
import { EDGE_RIGHTSHOLDER_ATTRIBUTION } from '../constants/config';

import './pacing.scss';
import { PacingContext } from './Context';

const Pacing = ({ pacing, deleteGoal, client }) => {
    const { t } = useTranslation('tools');
    const { isLoading, goals } = pacing;
    const { currentGoalId, setCurrentGoalId, filter } =
        useContext(PacingContext);
    const hasRhAttributionPermission = useMemo(
        () => client?.permissions?.includes(EDGE_RIGHTSHOLDER_ATTRIBUTION),
        [client],
    );

    const headers = useMemo(
        () =>
            buildHeaders({
                deleteGoal,
                setCurrentGoalId,
                filter,
                t,
                hasRhAttributionPermission,
            }),
        [deleteGoal, setCurrentGoalId, filter, t, hasRhAttributionPermission],
    );

    const getRowStyle = useCallback(
        (state, row) => {
            const selected =
                row && currentGoalId && row.original.id == currentGoalId;
            if (selected)
                return {
                    style: {
                        backgroundColor: 'var(--primary-light-70prct)',
                    },
                };
            return {};
        },
        [currentGoalId],
    );

    return (
        <ErrorBoundary FallbackComponent={CrashedComponent}>
            <Table
                data={goals}
                loading={isLoading}
                columns={headers}
                showPagination
                isStriped
                isHighlight
                preventHorizontalScroll
                defaultSorted={[
                    {
                        id: 'endDate',
                        asc: true,
                    },
                ]}
                isPrimary
                defaultPageSize={10}
                minRows={10}
                data-test={'pacing-table'}
                getTheadFilterThProps={() => {
                    return {
                        style: {
                            overflow: 'visible',
                            padding: '0.5rem',
                        },
                    };
                }}
                NoDataComponent={() => {
                    return !isLoading && goals.length === 0 ? (
                        <div className="-pos-abs rt-noData -no-goal-data">
                            {t('pacing.table.empty')}
                        </div>
                    ) : null;
                }}
                getTrProps={getRowStyle}
            />
        </ErrorBoundary>
    );
};

Pacing.propTypes = {
    pacing: PropTypes.object,
    deleteGoal: PropTypes.func,
    client: PropTypes.object,
};

export default connect(['pacing', 'client'], pacingActions)(Pacing);
